<template>
  <GenericStep v-bind="$attrs">
    <BackgroundOverviewCard class="mb-4" />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import BackgroundOverviewCard from '@/components/Party/PartyEdit/SectionCards/OverviewCards/BackgroundOverviewCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'

export default {
  name: 'BackgroundOverviewStep',

  components: {
    BackgroundOverviewCard,
    GenericStep,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty, [
          'num_entries',
          'date_first_entry',
          'date_first_entry_uncertain',
          'date_last_entry',
          'date_last_entry_uncertain',
          'departed_since_first_entry',
          'any_enforcement_history',
          'any_benefits_history',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
